import { getHomeInitDataAPI } from '@/api/home.js'

// 首页模块
const homeModule = {
  namespaced: true,
  state() {
    return {
      homeInitData: {},
      label:[]
    }
  },
  mutations: {
    getHomeInitData(state, initdata) {
      state.homeInitData = initdata
    },
    changeBreadcrumb(state,labelarr){
      let res = []
          labelarr.forEach(item => {
           
            res.push(item.meta.label)
          
          });
          state.crumb = res 
    },
     resetMassageNum(state) {
    // 安全访问message对象，避免undefined错误
    if (state.homeInitData.message) {
      state.homeInitData.message.message_num = 0;
    }
  }
  },
  actions: {
     clearMassageNum({ commit }) {
    commit('resetMassageNum');
  },
    async asyncGetHomeInitData({ commit }) {
      const { data: res } = await getHomeInitDataAPI()
      if (res.code !== 200) {
        return Promise.reject(new Error('获取数据失败！'))
      } else {
        commit('getHomeInitData', res.data)
        return { type: 'success', message: '登录成功！' }
      }
    }
  },
  getters: {
    mounthData(state) {
      const mounthObj = [[], []] // 默认返回包含两个空数组的结构
      if (state.homeInitData.monthdata && Array.isArray(state.homeInitData.monthdata)) {
        mounthObj[0] = state.homeInitData.monthdata.map(item => item['m'] || '')
        mounthObj[1] = state.homeInitData.monthdata.map(item => item['value'] || 0)
      }
      return mounthObj
    },
    weekDiffa(state) {
      const weekObj = [[], []] // 默认返回包含两个空数组的结构
      if (state.homeInitData.weekdiff && Array.isArray(state.homeInitData.weekdiff)) {
        weekObj[0] = state.homeInitData.weekdiff.map(item => item['m'] || '')
        weekObj[1] = state.homeInitData.weekdiff.map(item => item['value'] || 0)
      }
      return weekObj
    },
    textData(state) {
      let result = []
      if (state.homeInitData.textdata) {
        result = state.homeInitData.textdata
      }
      return result
    },
    mounthTop(state) {
      let result = []
      if (state.homeInitData.monthtopdata) {
        result = state.homeInitData.monthtopdata
      }
      return result
    },
    noticeList(state) {
      let result = []
      if (state.homeInitData.noticelist) {
        result = state.homeInitData.noticelist
      }
      return result
    },
    massageNum(state) {
      let result = null
      if (state.homeInitData.message) {
        result = state.homeInitData.message.message_num
      }
      return result === 0 ? '' : result
    }
  }
}
export default homeModule
